import React from "react";
import Draggable from "react-draggable";
import classnames from "classnames";
import styles from "./index.module.scss";
import Icon from "components/Icon";

const DragModal = ({
  title,
  content,
  bottom,
  showCloseButton,
  onCloseButtonClick,
  onMaskClick,
  draggable = true,
  maskType = "transparent",
  maskZIndex,
  headerColor,
  bodyColor,
  modalClassName,
  contentClassName,
  modalStyle,
}) => {
  const cssVars = {
    ...(headerColor && { "--header-color": headerColor }),
    ...(bodyColor && { "--body-color": bodyColor }),
    ...(modalStyle || {}),
  };

  const modal = (
    <div
      className={classnames(styles.dragModal, modalClassName)}
      style={Object.keys(cssVars).length ? cssVars : undefined}
      onClick={function(e) { e.stopPropagation(); }}
    >
      <div className={styles.draglHead}>
        <h1 className={styles.dragTitle}>{title}</h1>
        {showCloseButton && (
          <div className={styles.dragCloseButton} onClick={onCloseButtonClick}>
            <Icon className={styles.closeIcon} type="text" name="times" />
          </div>
        )}
      </div>
      <div className={classnames(styles.dragContent, contentClassName)}>
        {content}
      </div>
      <div className={styles.dragBottom}>{bottom}</div>
    </div>
  );

  return (
    <div
      className={classnames(styles.dragMask, {
        [styles.overlay]: maskType === "overlay",
      })}
      style={maskZIndex != null ? { zIndex: maskZIndex } : undefined}
      onClick={onMaskClick}
    >
      {draggable ? (
        <Draggable
          handle={`.${styles.draglHead}`}
          positionOffset={{ x: "-50%", y: "-50%" }}
        >
          {modal}
        </Draggable>
      ) : (
        modal
      )}
    </div>
  );
};

export default DragModal;
